export class applnInfo 
{
    applnname:string;
    applnlogo:string;
    applnurl:string;
    applnid:number;    
}